
import React from 'react';
import ServiceList from './ServiceList';
import { useTranslation } from 'react-i18next';

const ServiceSecTwo = ({ className }) => {
  const { t } = useTranslation();

  return (
    <section className={`bg-top-center ${className}`} id="service-sec" data-bg-src="assets/img/bg/bg-wave-shape1.png">
        <div className="container">
            <div className="title-area text-center">
                <span className="sub-title style2" data-cue="slideInUp">{t('sections.serviceSecTwo.sub_title','What We Offer')}</span>
                <h2 className="sec-title" data-cue="slideInUp">{t('sections.serviceSecTwo.title','Cloud Security Solutions')}</h2>
            </div>
            <div className="row justify-content-center">
                <ServiceList className="col-12 service-list-wrap" limit={4} />
            </div>
        </div>
    </section>
  );
};

export default ServiceSecTwo;